import type { FC } from 'react'

import {
  mdiBicycle,
  mdiCellphone,
  mdiEvStation,
  mdiFileSign,
  mdiHeadset,
  mdiImageOffOutline,
  mdiLaptop,
  mdiMonitor,
  mdiServerNetwork,
  mdiTablet,
  mdiUsb,
  mdiVideoInputComponent,
  mdiWatch,
  mdiPrinter,
  mdiBatteryCharging,
} from '@mdi/js'
import Icon from '@mdi/react'
import type { AssetType } from '@skytech/types'

export const AssetFallbackIcon: FC<{
  assetType: AssetType
  color?: string
  size?: number
  className?: string
}> = ({ assetType, color, size, className }) => {
  let icon = ''

  switch (assetType) {
    case 'TABLET':
      icon = mdiTablet
      break
    case 'MOBILE_PHONE':
      icon = mdiCellphone
      break
    case 'HEADSET':
      icon = mdiHeadset
      break
    case 'PC':
      icon = mdiLaptop
      break
    case 'SCREEN':
      icon = mdiMonitor
      break
    case 'DOCKING':
      icon = mdiUsb
      break
    case 'CAR_CHARGER':
      icon = mdiEvStation
      break
    case 'BIKE':
      icon = mdiBicycle
      break
    case 'AV_EQUIPMENT':
      icon = mdiVideoInputComponent
      break
    case 'SERVER_STORAGE_NETWORK':
      icon = mdiServerNetwork
      break
    case 'CONTRACT':
      icon = mdiFileSign
      break
    case 'SMART_WATCH':
      icon = mdiWatch
      break
    case 'PRINTER':
      icon = mdiPrinter
      break
    case 'UPS':
      // TODO: use mdiPowerPlugBattery after update @mdi/js to v7.0.0
      icon = mdiBatteryCharging
      break
    default:
      icon = mdiImageOffOutline
      break
  }

  return <Icon path={icon} size={size || 2} color={color || '#BEBEBE'} className={className} />
}
